<template>
  <section>
    <nav-component :titulo="'Historial de Inventario'" />
    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag='router-link' to="/">Inicio</b-breadcrumb-item>
      <b-breadcrumb-item active>Historial de Inventario</b-breadcrumb-item>
    </b-breadcrumb>
    <div class="columns">
      <div class="column is-flex">
        <b-select class="mr-1" v-model="perPage" @input="onPerPageChange">
          <option :value="5">5 por página</option>
          <option :value="10">10 por página</option>
          <option :value="15">15 por página</option>
          <option :value="20">20 por página</option>
          <option :value="null">Todos</option>
        </b-select>
        <b-select class="has-text-black" v-model="filtros.proveedor" @input="onProveedorChange">
          <option value="">Todos los proveedores</option>
          <option v-for="proveedor in proveedores" :value="proveedor.id" :key="proveedor.id">
            {{ proveedor.nombre }}
          </option>
        </b-select>
        <b-autocomplete
          class="ml-1"
          v-model="busquedaCliente"
          placeholder="Buscar cliente..."
          :data="clientesEncontrados"
          field="nombre"
          @input="buscarClientes"
          @select="seleccionarCliente"
          size="is-small"
        >
          <template slot-scope="props">
            <div>
              <span>{{ props.option.nombre }}</span>
              <span v-if="props.option.ci" class="has-text-grey is-size-7">
                &mdash; CI: {{ props.option.ci }}
              </span>
            </div>
          </template>
        </b-autocomplete>
      </div>
      <div class="column is-flex is-justify-content-end">
        <b-button type="is-primary" tag="a" :href="printHref" target="__blank" rel="noopener noreferrer">
          Imprimir
        </b-button>
      </div>
    </div>
    <div class="notification is-info mt-2" v-if="clienteSeleccionado">
      <button class="delete" @click="deseleccionarCliente"></button>
      <p>Cliente: <b>{{ clienteSeleccionado.nombre }}</b></p>
    </div>
    <busqueda-de-producto @seleccionado="onSeleccionadoProducto" @deseleccionado="onDeseleccionadoProducto" />
    <busqueda-en-fecha @seleccionada="onBusquedaEnFecha" />
    <br>
    <b-table class="box" :data="movimientos" :per-page="filasPorPagina" :paginated="usaPaginacion" :pagination-simple="false"
      :current-page="currentPage" :backend-pagination="usaPaginacion" :total="total" @page-change="onPageChange"
      :pagination-position="'bottom'" :default-sort-direction="'asc'" :pagination-rounded="true">
      <b-table-column field="nombreProducto" label="Producto" v-slot="props">
        {{ props.row.nombreProducto }}
      </b-table-column>

      <b-table-column field="cantidad" label="Cantidad" v-slot="props">
        <span class="has-text-weight-bold" :class="props.row.signo === '+' ? 'has-text-success' : 'has-text-danger'">
          {{ props.row.signo }}{{ props.row.cantidad }}
        </span>
      </b-table-column>

      <!-- Stock ACTUAL del producto, igual en todas las filas del mismo producto sin
           importar el tipo de movimiento de la fila. -->
      <b-table-column field="existencia_actual" label="Stock actual" v-slot="props">
        <span class="has-text-weight-bold"
          :class="Number(props.row.existencia_actual) < 0 ? 'has-text-danger' : 'has-text-black'">
          {{ redondearCantidad(props.row.existencia_actual) }} {{ props.row.unidad || '' }}
        </span>
      </b-table-column>

      <b-table-column field="tipo" label="Tipo" v-slot="props">
        {{ props.row.tipo }}
      </b-table-column>

      <b-table-column field="monto" label="Monto" v-slot="props">
        <span v-if="props.row.monto !== undefined">
          ${{ formatoMonto(props.row.monto) }}
        </span>
      </b-table-column>

      <b-table-column field="fecha" label="Fecha" v-slot="props">
      {{ new Date(props.row.fecha).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', }).replace(/\//g, '-') }}
      </b-table-column>

      <b-table-column field="nombreUsuario" label="Usuario" v-slot="props">
        {{ props.row.nombreUsuario || 'N/A' }}
      </b-table-column>

      <b-table-column field="nombreCliente" label="Cliente" v-slot="props">
        {{ props.row.nombreCliente || 'N/A' }}
      </b-table-column>

      <b-table-column field="nombreProveedor" label="Proveedor" v-slot="props">
        {{ props.row.nombreProveedor || 'N/A' }}
      </b-table-column>
    </b-table>
    <b-loading :is-full-page="true" v-model="cargando" :can-cancel="false"></b-loading>
  </section>
</template>
<script>
import NavComponent from '../Extras/NavComponent'
import HttpService from '../../Servicios/HttpService'
import Utiles from '../../Servicios/Utiles'
import BusquedaDeProducto from './BusquedaDeProducto.vue'
import BusquedaEnFecha from '../Extras/BusquedaEnFecha.vue'

export default {
  name: 'HistorialComponent',
  components: { NavComponent, BusquedaDeProducto, BusquedaEnFecha },

  data: () => ({
    cargando: false,
    movimientos: [],
    proveedores: [],
    currentPage: 1,
    total: 0,
    filtros: {
      proveedor: '',
      productoId: null,
      fechaInicio: "",
      fechaFin: "",
      cliente: null
    },
    busquedaCliente: '',
    clientesEncontrados: [],
    clienteSeleccionado: null,
    perPage: 10,
  }),

  async mounted() {
    this.filtros.proveedor = this.$route.query.proveedor || ''
    this.cargando = true

    try {
      await Promise.all([
        this.obtenerMovimientos(),
        this.obtenerProveedores(),
      ])
    } finally {
      this.cargando = false
    }
  },

  computed: {
    usaPaginacion() {
      return this.perPage !== null
    },
    filasPorPagina() {
      return this.perPage || this.total || 1
    },
    printHref() {
      let href = '#/pdf/movimientos'
      const entries = Object.entries(this.filtros)
        .filter(entry => Boolean(entry[1]))
      if (entries.length === 0) return href
      const filtros = Object.fromEntries(entries)
      const params = new URLSearchParams(filtros).toString()
      return `${href}?${params}`
    },
  },

  methods: {
    formatoMonto(valor) {
      return Utiles.formatoMonto(valor)
    },
    /** Cantidad sin colas de decimales (50, 1.5, -3). */
    redondearCantidad(valor) {
      return Utiles.redondearCantidad(valor)
    },
    obtenerMovimientos() {
      this.cargando = true

      let payload = {
        accion: 'historial',
        proveedor: this.filtros.proveedor || null,
        productoId: this.filtros.productoId || null,
        fechaInicio: this.filtros.fechaInicio || null,
        fechaFin: this.filtros.fechaFin || null,
        clienteId: this.filtros.cliente || null,
        pagina: this.currentPage,
        limite: this.perPage,
      }

      return HttpService.obtenerConConsultas('ventas.php', payload)
        .then(resultado => {
          this.movimientos = resultado.movimientos || []
          this.total = resultado.total || 0
        })
        .finally(() => {
          this.cargando = false
        })
    },

    obtenerProveedores() {
      let payload = {
        accion: 'obtener',
      }

      return HttpService.obtenerConConsultas('proveedores.php', payload)
        .then(proveedores => {
          this.proveedores = proveedores
        })
    },
    buscarClientes() {
      if (!this.busquedaCliente || !this.busquedaCliente.trim()) {
        this.clientesEncontrados = []
        return
      }

      let payload = {
        accion: 'obtener_por_nombre',
        nombre: this.busquedaCliente
      }
      HttpService.obtenerConConsultas('clientes.php', payload)
        .then(clientes => {
          this.clientesEncontrados = clientes
        })
    },
    seleccionarCliente(opcion) {
      if (!opcion) return
      this.clienteSeleccionado = opcion
      this.filtros.cliente = opcion.id
      this.currentPage = 1
      this.obtenerMovimientos()
      setTimeout(() => this.busquedaCliente = '', 10)
    },
    deseleccionarCliente() {
      this.busquedaCliente = ''
      this.clientesEncontrados = []
      this.clienteSeleccionado = null
      this.filtros.cliente = null
      this.currentPage = 1
      this.obtenerMovimientos()
    },
    onProveedorChange() {
      this.currentPage = 1
      this.obtenerMovimientos()
    },
    onSeleccionadoProducto(producto) {
      this.filtros.productoId = producto.id
      this.currentPage = 1
      this.obtenerMovimientos()
    },
    onDeseleccionadoProducto() {
      this.filtros.productoId = null
      this.currentPage = 1
      this.obtenerMovimientos()
    },
    onBusquedaEnFecha(fechas) {
      this.filtros.fechaInicio = fechas[0]?.toISOString().split('T')[0] || ""
      this.filtros.fechaFin = fechas[1]?.toISOString().split('T')[0] || ""
      this.currentPage = 1
      this.obtenerMovimientos()
    },
    onPageChange(page) {
      this.currentPage = page
      this.obtenerMovimientos()
    },
    onPerPageChange() {
      this.currentPage = 1
      this.obtenerMovimientos()
    },
  },
}
</script>
